import { MapModalData } from './map-redirect-modal.component';
import { pointsMinZoom } from '../../shared/util/consts';

export const ROUTER_NAVIGATE = 'ROUTER_NAVIGATE';
export const MAPBOX_JUMP_TO = 'MAPBOX_JUMP_TO';
export const MAPBOX_CHANGE_ZOOM = 'MAPBOX_CHANGE_ZOOM';

export const subscriptionRequiredText: MapModalData = {
  headerText: 'Subscription required',
  mainText: 'To see information about this area, select a',
  linkText: 'Subscription plan',
  linkURL: '/user/subscription',
  buttonText: 'To Subscriptions',
  URLtoGo: '/user/subscription',
  actionType: ROUTER_NAVIGATE,
  disableClose: false,
};

export const registrationRequiredText: MapModalData = {
  headerText: 'Unlock for free!',
  mainText:
    "Get the neighborhood insights you need - free trial, no card required.",
  hasBackdrop: false,
  linkURL: '/sign-up/individual',
  buttonText: 'Sign up',
  URLtoGo: '/sign-up/individual',
  actionType: ROUTER_NAVIGATE,
  disableClose: true,
};

export const limitedCellsResolutionText: MapModalData = {
  headerText: 'High resolution data',
  mainText: 'Higher resolution data is not accessible for this subscription',
  buttonText: 'To Subscriptions',
  URLtoGo: '/user/subscription',
  actionType: ROUTER_NAVIGATE,
  disableClose: false,
  hasBackdrop: true,
};

export const dataIsNotAvailableForLevelText: MapModalData = {
  headerText: 'Data is not available at the selected level',
  subHeaderText: 'The map will be displayed in gray',
  disableClose: false,
  hasBackdrop: true,
};

export const zoomInText: MapModalData = {
  headerText: 'Places on the map',
  mainText:
    'Points of interest are visible on Map AI only when you zoom in to the level of 1 mile cells',
  buttonText: 'Zoom in',
  actionType: MAPBOX_CHANGE_ZOOM,
  jumpToZoom: pointsMinZoom,
};

export const signInToAccessReports: MapModalData = {
  headerText: 'Reports',
  mainText: 'Sign in to access this page',
  buttonText: 'To sign in',
  URLtoGo: '/sign-in',
  actionType: ROUTER_NAVIGATE,
  disableClose: false,
  hasBackdrop: true,
};

export const signIn: MapModalData = {
  headerText: 'Sign in',
  mainText: 'Please sign in again',
  buttonText: 'To sign in',
  URLtoGo: '/sign-in',
  actionType: ROUTER_NAVIGATE,
  disableClose: false,
  hasBackdrop: true,
};
